export default __webpack_public_path__ + "static/media/addon.cbf7f4dc.png";